import { withSvgIcon } from './withSvgIcon';

export const Dot = withSvgIcon(
  <circle cx="10" cy="10" r="4" fill="currentColor" />,
  { viewBox: '0 0 20 20' },
);
